export enum RoleType {
    Common = 1,
    System = 2
}